import { createStyles, ScrollArea, Text } from '@mantine/core'
import React, { useState } from 'react'
import { Virtuoso } from 'react-virtuoso'

const useStyles = createStyles((theme, { height }: { height: number }) => ({
  scrollAreaRoot: {
    width: '100%',
    height,
    overflow: 'hidden',
  },
  scrollbars: {
    backgroundColor: 'inherit',
    [`&:hover`]: {
      backgroundColor:
        theme.colorScheme === 'light'
          ? theme.colors.gray[1]
          : theme.colors.dark[7],
    },
  },

  scrollAreaWidthFix: {
    height: '100%',
    width: '100%',
    [`> div:first-of-type`]: {
      display: 'block !important',
    },
  },
}))

type ErrorsListProps = {
  errors: string[]
}

const ErrorsList = ({ errors }: ErrorsListProps): React.ReactElement => {
  const height = 400
  const { classes } = useStyles({
    height,
  })
  const [scrollParent, setScrollParent] = useState<HTMLDivElement | null>(null)

  return (
    <ScrollArea
      sx={{ height }}
      offsetScrollbars
      type="always"
      viewportRef={(r) => setScrollParent(r)}
      classNames={{
        root: classes.scrollAreaRoot,
        viewport: classes.scrollAreaWidthFix,
        scrollbar: classes.scrollbars,
      }}
    >
      <Virtuoso
        followOutput={false}
        data={errors}
        itemContent={(_index, error) => {
          return <Text>{error}</Text>
        }}
        customScrollParent={scrollParent ?? undefined}
      />
    </ScrollArea>
  )
}

export default ErrorsList
